<mat-dialog-content>
   <div *ngIf="member">
      <H2>{{member.name}} {{member.lastName}}</H2>
      <p class="totals"><small>€{{productStarting}} / </small><Strong>€{{productFinal}}</Strong>, <span>Payments: €{{payments}}</span> <Strong [ngClass]="{'balance' : balance !=0 }">, Balance: €{{balance}}</Strong></p>
      <mat-tab-group>
         <mat-tab>
            <ng-template mat-tab-label>
               <mat-icon class="example-tab-icon">person</mat-icon>
               Member
             </ng-template>
            <div class="mat-tab-content">
               <p>Age: {{member.age}}</p>
               <p>Sex:{{member.sex}}</p>
               <p>Country:{{member.countryCode}}</p>
               <p>Registered at: {{member.dateTimeEntered | date :'dd-MM-yy HH:mm'}}</p>
               <p>Email: {{member.email}}</p>
               <p>Marketing Channel: {{member.sourceDescription}}</p>
               <p>Id/Passport: {{member.idPassport}}</p>
               <p>
                  <mat-checkbox class="example-margin" [(ngModel)]="member.agreedOnGDPR" [disabled]="true">Agred on GDPR</mat-checkbox>
               </p>
               <p>
                  <mat-checkbox class="example-margin" [(ngModel)]="member.agreedOnTerms" [disabled]="true">Agred on Terms</mat-checkbox>
               </p>
               <p>
                  <mat-checkbox class="example-margin" [(ngModel)]="member.isMvpPlayer" (change)="toggleMvpPlayer()">MVP Player</mat-checkbox>
               </p>
               <p>Signature</p>
               <p>
                  <img src="{{member.signatureData}}"  width="280"/>
               </p>
            </div>

         </mat-tab>
         <mat-tab>
            <ng-template mat-tab-label>
               <mat-icon class="example-tab-icon">inventory_2</mat-icon>
               Products
             </ng-template>
            <div class="mat-tab-content">
               <div *ngIf="adminApp && adminApp.products">
                  <button mat-raised-button (click)="addProduct(product)" class="product-button" color="primary" *ngFor="let product of adminApp.products">+ {{product.description}}</button>
               </div>
               <div *ngIf="member?.memberProducts">
                  <div *ngFor="let memberProduct of member.memberProducts">
                     <mat-form-field   style="width: 340px;">
                        <input matInput [(ngModel)]="memberProduct.description" readonly tabindex="999999">
                      </mat-form-field>
                      <mat-form-field  style="width: 100px;">
                        <mat-label>Final Price</mat-label>
                        <input matInput [(ngModel)]="memberProduct.finalPrice" (keydown.Tab)="fixTotals()"  (focusout)="fixTotals()"  type="number">
                      </mat-form-field>
                      <button mat-raised-button tabindex="999999" (click)="deleteProduct(memberProduct)" color="warn" class="product-button"><mat-icon>delete</mat-icon></button>
                  </div>
               </div>
            </div>
         </mat-tab>
         <mat-tab>
            <ng-template mat-tab-label>
               <mat-icon class="example-tab-icon">euro</mat-icon>
               Payments
             </ng-template>
            <div class="mat-tab-content">
               <div *ngIf="adminApp && adminApp.paymentMethods">
                  <button mat-raised-button (click)="addPaymentMethod(paymentMethod)" class="product-button" color="primary" *ngFor="let paymentMethod of adminApp.paymentMethods">+ {{paymentMethod.description}}</button>
               </div>
               <div *ngIf="member?.memberPaymentMethods">
                  <div *ngFor="let memberPaymentMethod of member.memberPaymentMethods">
                     <mat-form-field style="width: 340px;">
                        <input matInput [(ngModel)]="memberPaymentMethod.description" readonly tabindex="999999">
                      </mat-form-field>
                      <mat-form-field  style="width: 100px;">
                        <mat-label>€</mat-label>
                        <input matInput [(ngModel)]="memberPaymentMethod.amount"  (keydown.Tab)="fixTotals()" (focusout)="fixTotals()" type="number">
                      </mat-form-field>
                      <button mat-raised-button tabindex="999999" (click)="deletePaymentMethod(memberPaymentMethod)" color="warn" class="product-button"><mat-icon>delete</mat-icon></button>
                  </div>
               </div>
            </div>
         </mat-tab>
         <mat-tab>
            <ng-template mat-tab-label>
               <mat-icon class="example-tab-icon">link</mat-icon>
               Links
             </ng-template>
            <div class="mat-tab-content">
               <button mat-raised-button (click)="addLink()" class="product-button" color="primary"><mat-icon>add</mat-icon></button>
               <div *ngIf="member?.memberLinks">
                  <div *ngFor="let memberLink of member.memberLinks">
                      <mat-form-field style="width: 440px;" >
                        <mat-label>URL</mat-label>
                        <input matInput [(ngModel)]="memberLink.linkUrl" >
                      </mat-form-field>
                      <button mat-raised-button  tabindex="999999" (click)="deleteLink(memberLink)" color="warn" class="product-button"><mat-icon>delete</mat-icon></button>
                  </div>
               </div>
               <button mat-raised-button (click)="sendMemberEmail('A')" class="email-button" color="primary"><mat-icon>email</mat-icon>Email Jump Video EN </button>
               <button mat-raised-button (click)="sendMemberEmail('AGR')" class="email-button" color="primary"><mat-icon>email</mat-icon>Email Jump Video GR </button>

               <button mat-raised-button (click)="sendMemberEmail('B')" class="email-button" color="primary"><mat-icon>email</mat-icon>Email Drone Video EN </button>
               <button mat-raised-button (click)="sendMemberEmail('BGR')" class="email-button" color="primary"><mat-icon>email</mat-icon>Email Drone Video GR </button>

            </div>
         </mat-tab>
      </mat-tab-group>
   </div>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="!isLoading">
   <button style="margin-right: 28px;" class="product-button" mat-raised-button color="warn" [mat-dialog-close]="true"><mat-icon>close without saving</mat-icon>Close</button>
   <button class="product-button" mat-raised-button color="primary" cdkFocusInitial (click)="save(false)"><mat-icon>check</mat-icon>Save</button>
   <button class="product-button" mat-raised-button color="primary" cdkFocusInitial (click)="save(true)"><mat-icon>check</mat-icon>Save & Close</button>
</mat-dialog-actions>